<template>
  <v-col cols="3" sm="3" md="3" justify="center">
    <v-date-picker
      full-width
      light
      no-title
      first-day-of-week="1"
      v-model="currentDate"
      :picker-date.sync="pickerDate"
    >
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!currentDate"
        color="primary"
        text
        full
        @click="addService"
        >Crear servicio</v-btn
      >
    </v-date-picker>
    <br />
    <v-card>
      <v-card-text class="search-bar">
        <v-text-field
          type="search"
          placeholder="Receta"
          v-model="recipeName"
          @keyup="changeSearch"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!recipeName || recipeName.length < 4"
          small
          text
          @click="addRecipe(recipeName)"
          name="newrecipe"
          >Nueva receta</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      db: firebase.firestore(),
      pickerDate: null,
      recipeName: "",
      currentDate: new Date().toISOString().split("T")[0],
    };
  },
  methods: {
    changeSearch: function () {
      this.$store.commit("setSearchRecipe", this.recipeName);
    },
    addRecipe: function () {
      let recipes = this.recipeName.split(";");
      this.recipeName = "";
      this.$store.commit("setSearchRecipe", "");
      recipes.forEach((recipe) => {
        if (recipe.trim() !== "") {
          let id = generateId();
          this.db
            .collection("recipes")
            .doc(id)
            .set({
              id: id,
              name: recipe,
              ordername: getOrderName(recipe),
              rating: 0,
              comments: [],
            });
        }
      });
    },
    addService: function () {
      console.log("CREANDO SERVICIO");
      let id = generateId();
      this.db
        .collection("services")
        .doc(id)
        .set({
          id: id,
          date: new Date(this.currentDate),
          month: this.pickerDate,
          recipes: {
            first: [],
            second: [],
            desert: [],
            garnish: [],
          },
          rating: 0,
          comments: [],
          code: generateCode(),
          editing: true,
        })
        .then(() => {
          console.log("hola");
          this.currentDate = "";
        });
    },
  },
  watch: {
    pickerDate: function (val) {
      this.$store.commit("setCurrentMonth", val);
      this.$store.dispatch("readServices");
    },
  },
};

function generateCode() {
  let code = "";
  let digits = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ123456789";
  for (let i = 0; i < 6; i++) {
    code += digits[Math.floor(digits.length * Math.random())];
  }
  return code;
}

function generateId() {
  let code = "";
  let digits = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ123456789";
  for (let i = 0; i < 20; i++) {
    code += digits[Math.floor(digits.length * Math.random())];
  }
  return code;
}

function getOrderName(str) {
  var theString = str.toLowerCase();
  return theString.replace(/[áàäâéèëêíìïîóòöôúùüûñç]/gi, (x) => {
    if ("áàäâ".indexOf(x) > -1) return "a";
    if ("éèëê".indexOf(x) > -1) return "e";
    if ("íìïî".indexOf(x) > -1) return "i";
    if ("óòöô".indexOf(x) > -1) return "o";
    if ("úùüû".indexOf(x) > -1) return "u";
    if (x === "ñ") return "nzzz";
    if (x === "ç") return "czzz";
  });
}
</script>

<style lang="scss" scoped>
</style>